module.exports = __webpack_public_path__ + "static/media/_DSC6583.f50dabb6.jpg";